const staticConfig = {
  tileServer: {
    url: "https://cyberjapandata.gsi.go.jp"
  }
};

const cognitoConfig = {
  Region: "ap-northeast-1",
  UserPoolId: "ap-northeast-1_jcN9cPbug",
  ClientId: "uvdm10msdmi9d9rhkrilrb8b3",
  IdentityPoolId: "ap-northeast-1:db82cdb0-e627-4b87-b0f9-7af51e8260fb"
};

const apiConfig = {
  baseUrl: "https://data.riskma.net/bosai"
  // baseUrl: "https://sl3mgfgby8.execute-api.ap-northeast-1.amazonaws.com/dev/bosai"
};

export { staticConfig, cognitoConfig, apiConfig };
